/* Product rails progressively enhance native scrolling; no generated activity claims. */
(() => {
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  class ProductRail extends HTMLElement {
    connectedCallback() {
      if (this.cleanup) return;
      const track = this.querySelector('.product-stories__grid, .reels__track, .quotes__track');
      if (!track) return;
      if (this.hasAttribute('data-product-rounds')) {
        const groups = new Map();
        [...track.children].forEach((card, index) => {
          const id = card.dataset.storyProduct || `unlinked-${index}`;
          if (!groups.has(id)) groups.set(id, {created: Number(card.dataset.storyCreated) || 0, cards: []});
          groups.get(id).cards.push(card);
        });
        const products = [...groups.values()].sort((a, b) => b.created - a.created);
        const rounds = Math.max(0, ...products.map(p => p.cards.length));
        const ordered = document.createDocumentFragment();
        for (let round = 0; round < rounds; round++) {
          products.forEach(product => {if (product.cards[round]) ordered.append(product.cards[round]);});
        }
        track.append(ordered);
      }

      const controls = document.createElement('div');
      controls.className = 'product-rail-controls';
      controls.innerHTML = '<button type="button" aria-label="Previous slide">←</button><button type="button" data-pause>Pause slideshow</button><button type="button" aria-label="Next slide">→</button>';
      this.append(controls);
      let paused = reduced.matches, hovering = false, visible = false;
      const cadence = this.querySelector('video') ? 3000 : 2000;
      let nextSlide = Date.now() + cadence, nativeFullscreen = false, manualVideo = null, waitingForVideo = false, videoProgressAt = 0;
      const fullscreen = () => nativeFullscreen || !!(document.fullscreenElement || document.webkitFullscreenElement);
      const manualStep = direction => {if(manualVideo){manualVideo.loop=true;manualVideo=null;} waitingForVideo=!!this.querySelector('video');nextSlide = Date.now() + (waitingForVideo ? 8000 : cadence); step(direction); refresh();};
      const pause = controls.querySelector('[data-pause]');
      const cards = () => [...track.children].filter(c => !c.hidden);
      const refresh = () => {
        controls.hidden = cards().length < 2 || track.scrollWidth <= track.clientWidth + 2;
        pause.textContent = paused ? 'Play slideshow' : 'Pause slideshow';
        pause.setAttribute('aria-pressed', String(paused));
      };
      let moving = false, settleTimer;
      const watch = () => mutation.observe(track, {childList:true, subtree:true, attributes:true, attributeFilter:['hidden']});
      const step = direction => {
        const items = cards();
        if (items.length < 2 || moving) return;
        moving = true;
        const gap = parseFloat(getComputedStyle(track).gap) || 0;
        const distance = items[0].getBoundingClientRect().width + gap;
        mutation.disconnect();
        track.style.scrollSnapType = 'none';
        if (direction < 0) {
          track.prepend(items[items.length - 1]);
          track.scrollTo({left:track.scrollLeft + distance, behavior:'instant'});
        }
        const target = direction > 0 ? distance : 0;
        const finish = () => {
          clearTimeout(settleTimer);
          track.removeEventListener('scrollend', finish);
          if (direction > 0) track.append(items[0]);
          track.scrollTo({left:0, behavior:'instant'});
          track.style.scrollSnapType = '';
          moving = false;
          watch();
          syncVideo();
        };
        track.addEventListener('scrollend', finish, {once:true});
        track.scrollTo({left:target, behavior:reduced.matches ? 'instant' : 'smooth'});
        settleTimer = setTimeout(finish, reduced.matches ? 30 : 900);
      };
      const controller = new AbortController(), options = {signal: controller.signal};
      controls.children[0].addEventListener('click', () => manualStep(-1), options);
      controls.children[2].addEventListener('click', () => manualStep(1), options);
      pause.addEventListener('click', () => {paused = !paused; refresh();}, options);
      this.addEventListener('pointerenter', e => {if(e.pointerType==='mouse')hovering = true;}, options);
      this.addEventListener('pointerleave', () => {hovering = false;}, options);
      track.addEventListener('pointerdown', () => {hovering = true;}, options);
      const releaseTouch = () => {hovering = false;nextSlide=Math.max(nextSlide,Date.now()+cadence);};
      track.addEventListener('pointerup', releaseTouch, options);
      track.addEventListener('pointercancel', releaseTouch, options);
      track.addEventListener('touchstart', () => {hovering=true;}, {...options,passive:true});
      track.addEventListener('touchend', releaseTouch, {...options,passive:true});
      track.addEventListener('touchcancel', releaseTouch, {...options,passive:true});
      this.addEventListener('focusin', e => {if (!controls.contains(e.target)) {paused = true; refresh();}}, options);
      reduced.addEventListener('change', () => {if (reduced.matches) paused = true; refresh();}, options);
      const observer = new IntersectionObserver(entries => {visible = entries[0].isIntersecting;}, {threshold: 0.25});
      observer.observe(this);
      const resize = new ResizeObserver(refresh); resize.observe(track);
      const mutation = new MutationObserver(() => {track.scrollLeft = 0; refresh(); syncVideo();});
      mutation.observe(track, {childList: true, subtree: true, attributes: true, attributeFilter: ['hidden']});
      const fullscreenChanged = () => {nextSlide = Date.now() + cadence;};
      this.addEventListener('ended', event => {const video=event.target;if(video!==manualVideo)return;video.loop=true;manualVideo=null;waitingForVideo=false;nextSlide=Date.now();}, {...options,capture:true});
      document.addEventListener('fullscreenchange', fullscreenChanged, options);
      document.addEventListener('webkitfullscreenchange', fullscreenChanged, options);
      this.querySelectorAll('video').forEach(video => {
        video.addEventListener('timeupdate', () => {if(video===manualVideo)videoProgressAt=Date.now();}, options);
        video.addEventListener('ended', () => {if(video!==manualVideo)return;video.loop=true;manualVideo=null;waitingForVideo=false;nextSlide=Date.now();}, options);
        video.addEventListener('webkitbeginfullscreen', () => {nativeFullscreen = true;}, options);
        video.addEventListener('webkitendfullscreen', () => {nativeFullscreen = false; nextSlide = Date.now() + cadence;}, options);
      });
      const timer = setInterval(() => {
        if (fullscreen() || (manualVideo && !manualVideo.paused && !manualVideo.ended && Date.now()-videoProgressAt<8000) || Date.now() < nextSlide || paused || hovering || !visible || document.hidden || controls.hidden || document.querySelector('dialog[open],ha-drawer.is-open')) return;
        if(manualVideo){manualVideo.loop=true;manualVideo=null;}waitingForVideo=false;
        nextSlide = Date.now() + cadence;
        step(1);
      }, 250);
      let videoTimer;
      const syncVideo = () => {
        clearTimeout(videoTimer);
        if (fullscreen()) return;
        videoTimer = setTimeout(() => {
          const center = track.getBoundingClientRect().left + track.clientWidth / 2;
          const items = cards();
          const active = items.reduce((best, card) => !best || Math.abs(card.getBoundingClientRect().left + card.clientWidth / 2-center) < Math.abs(best.getBoundingClientRect().left + best.clientWidth / 2-center) ? card : best, null);
          const activeIndex=items.indexOf(active);
          if(visible && !navigator.connection?.saveData){[activeIndex,(activeIndex+1)%items.length].forEach(index=>{const video=items[index]?.querySelector('video');if(video&&video.preload!=='auto'){video.preload='auto';if(video.readyState===0)video.load();}});}
          this.querySelectorAll('video').forEach(v => {
            if (visible && !document.hidden && !reduced.matches && active?.contains(v)) {if(waitingForVideo){manualVideo=v;videoProgressAt=Date.now();waitingForVideo=false;v.loop=false;v.currentTime=0;}v.muted = true; v.playsInline = true; v.play().catch(() => {});}
            else v.pause();
          });
        }, 40);
      };
      track.addEventListener('scroll', syncVideo, options);
      document.addEventListener('visibilitychange', syncVideo, options);
      const videoObserver = new IntersectionObserver(syncVideo, {threshold: [0,.25,.5,.75]}); videoObserver.observe(this);
      refresh();
      this.cleanup = () => {clearInterval(timer); clearTimeout(settleTimer); clearTimeout(videoTimer); videoObserver.disconnect(); controller.abort(); observer.disconnect(); resize.disconnect(); mutation.disconnect(); controls.remove();};
    }
    disconnectedCallback() {this.cleanup?.(); this.cleanup = null;}
  }
  const activityTimer = setInterval(() => {if (!document.hidden) document.querySelectorAll('[data-demo-shoppers]').forEach(el => {el.textContent = String(3 + Math.floor(Math.random() * 7));});}, 8500);
  addEventListener('pagehide', () => clearInterval(activityTimer));
  if (!customElements.get('product-social-rail')) customElements.define('product-social-rail', ProductRail);
})();

/* Clearly labelled sale-countdown samples, scoped to each product. */
(()=>{const clocks=[...document.querySelectorAll('[data-demo-sale-clock]')];if(!clocks.length)return;const key='ha-demo-sale-end:'+location.pathname;let end=0;try{end=Number(sessionStorage.getItem(key))||0;}catch{}function update(){if(!Number.isFinite(end)||end<=Date.now()){end=Date.now()+(3180+Math.floor(Math.random()*3241))*1000;try{sessionStorage.setItem(key,String(end));}catch{}}const seconds=Math.max(0,Math.ceil((end-Date.now())/1000));const text=[Math.floor(seconds/3600),Math.floor(seconds%3600/60),seconds%60].map(n=>String(n).padStart(2,'0')).join(':');clocks.forEach(el=>el.textContent=text);}update();const timer=setInterval(update,1000);addEventListener('pagehide',()=>clearInterval(timer));})();

/* Warm nearby video media before it enters the viewport. */


/* Keep native controls out of autoplay; reveal them on intentional interaction. */
(()=>{
 const bound=new WeakSet();
 function init(root=document){root.querySelectorAll('.product-stories video, product-focus video, .reels video').forEach(video=>{
  if(bound.has(video))return;bound.add(video);video.controls=false;video.tabIndex=0;let timer,nativeFull=false;
  const full=()=>nativeFull||document.fullscreenElement===video||document.webkitFullscreenElement===video;
  const hide=()=>{if(full())return;video.controls=false;};
  const reveal=()=>{video.controls=true;clearTimeout(timer);timer=setTimeout(hide,4000);};
  video.addEventListener('click',reveal);
  video.addEventListener('keydown',e=>{if(e.key==='Enter'||e.key===' '){e.preventDefault();reveal();}});
  video.addEventListener('focus',reveal);
  video.addEventListener('pointerdown',()=>clearTimeout(timer));
  video.addEventListener('pointerup',()=>{if(video.controls){clearTimeout(timer);timer=setTimeout(hide,4000);}});
  video.addEventListener('pause',()=>{if(!full()){clearTimeout(timer);hide();}});
  video.addEventListener('webkitbeginfullscreen',()=>{nativeFull=true;video.controls=true;});
  video.addEventListener('webkitendfullscreen',()=>{nativeFull=false;hide();});
 });}
 init();document.addEventListener('shopify:section:load',e=>init(e.target));
})();
